export default "__VITE_ASSET__DYPFIf3T__"